<template functional>
  <div v-if="$options.methods.hasPower(props)">
    {{ props.row[props.column.field] }} kW ({{ $options.methods.getHorsepower(props) }} PS)
  </div>
</template>

<script>
import { isEmpty, kilowattsToHorsepower } from '@/helpers/utils'

export default {
  name: 'MiaCarSearchDatatablePowerColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    hasPower({ row, column }) {
      return !isEmpty(row[column.field]) && row[column.field] !== 0
    },

    getHorsepower({ row, column }) {
      return Math.floor(kilowattsToHorsepower(row[column.field]))
    }
  }
}
</script>
